import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserNotificationService } from '@ca/core/services';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorContext } from '../models/error-context.model';

/*
  Use it in service methods:
  const errorContext: ErrorContext = { isEnabled: true, errors: [{ code: 400, key: 'GENERAL.BAD_REQUEST' }] };
  this.http.get<T>(`${this.API_URL}/${id}`, {
            headers: this.HEADERS,
            context: new HttpContext().set(errorContextToken, errorContext),
        });
 */

export const errorContextToken = new HttpContextToken<ErrorContext>(() => {
    return {
        isEnabled: false,
        errors: [],
    };
});

@Injectable()
export class GlobalErrorInterceptor implements HttpInterceptor {
    constructor(private userNotificationService: UserNotificationService) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            catchError((error: unknown) => {
                const { isEnabled, errors } = req.context.get(errorContextToken);
                if (isEnabled && error instanceof HttpErrorResponse) {
                    const httpErrorResponse = error;
                    const errorKey = errors.find(error => error.code === httpErrorResponse.status)?.key || this.getErrorKey(httpErrorResponse.status);
                    this.userNotificationService.showError(errorKey);
                }
                return throwError(error);
            }),
        );
    }

    private getErrorKey(status: number) {
        let key: string;
        if (status === 400) {
            key = 'GENERAL.BAD_REQUEST';
        } else if (status === 404) {
            key = 'GENERAL.NOT_FOUND';
        } else {
            key = 'GENERAL.SERVER_ERROR';
        }
        return key;
    }
}
